module.exports = __webpack_public_path__ + "static/media/football.e57e8780.svg";